export default {
  state: {
    button: {
      optButtonWallet: false,
      optButtonOnline: true
    },
    optDisplay: {
      bank: "Seleccionado pagamento por MCX Express",
      wallet: "Seleccionado pagamento por carteira"
    }
  },
  mutations: {
    SET_BUTTON_WALLET(state, value) {
      state.button.optButtonWallet = value;
    },
    SET_BUTTON_ONLINE(state, value) {
      state.button.optButtonOnline = value;
    },
    // SET_OPT_DISPLAY_WALLET(state, value) {
    //   state.optDisplay.wallet = value;
    // },
    // SET_OPT_DISPLAY_MCX(state, value) {
    //   state.optDisplay.bank = value;
    // }
  },
  actions: {
    setButtonWallet(context, value) {
      context.commit("SET_BUTTON_WALLET", value);
      context.commit("SET_BUTTON_ONLINE", false);
    },
    setButtonOnline(context, value) {
      context.commit("SET_BUTTON_ONLINE", value);
      context.commit("SET_BUTTON_WALLET", false);
    }
  },

  getters: {
    getButtonWallet(state) {
      return state.button.optButtonWallet;
    },
    getButtonOnline(state) {
      return state.button.optButtonOnline;
    },
    getDisplayMcx(state) {
      return state.optDisplay.bank;
    },
    getDisplayWallet(state) {
      return state.optDisplay.wallet;
    }
  }
};
